import { Component, OnInit, Input, HostListener, ChangeDetectorRef, Inject } from '@angular/core';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TestRegistrationConfirmDialogComponent } from '@app-shared/components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { states } from '@subscription-constants/subscriptionconstant';
import { environment } from '@app-environments/environment';
import { NgZone } from '@angular/core';
import {GAnalyticsService} from '@app-services/g-analytics/g-analytics.service';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Bank} from '@app-modules/feature/subscription/my-subscription-part-payment/my-subscription-part-payment.component';
import {Observable, Subscription} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {RazorpayapiService} from 'src/app/razorpayapi.service';
import {ToastrService} from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@app-services/user/user.service';
import { CommunicationMessageService } from '@app-services/communication-message/communication-message.service';
declare let $: any;

@Component({
  selector: 'app-festival-payment',
  templateUrl: './festival-payment.component.html',
  styleUrls: ['./festival-payment.component.scss']
})
export class FestivalPaymentComponent implements OnInit {
  pacakgeSelected: any;
  validitySelected: any;
  userDetails: any;
  selectedBatch: any;
  discountCode: any;
  selectedDateAndTime: any;
  courseSelected: any;
  selectedSubscriptionDetails:any;
  subscriptionbillingUtility: any = {
    selectedPackage: {},
    selectedBatch:{},
    selectedDuration: [],
    userDetails: {},
    today: new Date(),
    stateName: '',
    discountAmount: 0,
    states: states,
    selectedDateAndTime: {},
    localUserData:{},
    courseSelected:{},
    subscriptionPacakgeIdList: [],
    packageSubscriptionAmountList: [],
    finalDTOArray: [],
    partPaymentDetailPlan: [],
    selectedCartItems: [],
    discountCodecoupounPer: 0,
    Emioptions: [],
    selectedEmiPart: 0,
    totalAmount:0,
    fulltotalAmount:0,
    emiPayLaterFulltotalAmount:0,
    totalAmount_withoutdiscount:0,
    partPaymentDiscountper:0,
    totalPaidAmount: 0,
    discountPercentage:0
  };
  paymentValue: any;
  public rzp: any;
  public options2: any;
  public openPartapaystatus: boolean = false;
  public openCartOrderReviewBoxstatus: boolean = false;
  subscription: Subscription;
  totalPartPaymentAmt: number = 0;
  totalItemQuantity: number = 0;
  selectedPartOptions:any;

  razorPayData: any;

    // custom payment variable
    paymentGatewayCode: "RAZORPAY" | "SIMPL" | "BAJAJFINANCE";
    paymentType: "fullpayment" | "partpayment" = "fullpayment";
    newCardForm!: FormGroup;
    selctedCardData: any = {};
    customPaymntType: string = 'card';
    customPaymntPanelStatus:boolean = false;
    innerPanelName: string = 'addNewCard';
  
    // net banking dropdown variable
    selectedBankName: any;
    popularBanksList = [
      { name: "HDFC Bank", code: "HDFC" },
      { name: "ICICI Bank", code: "ICIC" },
      { name: "AXIS Bank", code: "UTIB" },
      { name: "Kotak Mahindra Bank", code: "KKBK" },
      { name: "State Bank of India", code: "SBIN" },
      { name: "Yes Bank", code: "YESB" },
      { name: "IDBI", code: "IBKL" },
      { name: "BOB", code: "BARB_R" },
      { name: "PNB", code: "PUNB_R" },
    ];
    popularBanks = [];
    bankControlForm!: FormGroup;
    options: Bank[] = [];
    filteredOptions: Observable<Bank[]>;
  
    // UPI
    UPIControlForm!: FormGroup;
    isUPIValid: boolean = false;
    isUPIVerified: boolean = false;
    upicheckLoading: any;
    upiMode: any;
  
    // wallets
    selectedWalletCode: any;
    wallets = [];
  
    // emi
    emi_data: any = [];
    validEmiData: any;
    hasDebitCardEMI: any;
    hasCreditCardEMI: any;
    selected_bank_emi_data: any;
    selectedEmiPlan: any;
    emiMode: any;
    EMICardForm!: FormGroup;
    BajajEMICardForm!: FormGroup;
    selctedEMICardData: any;
    selctedBajajEMICardData: any;
    EMICardErrorMSg: any;
    BajajEMICardErrorMSg: any;
    BajajEMIOtpErrorMSg: any;
    bajajFinanceNoCostEmiData: any = {
      showBajaj: environment.Bajaj.showBajaj,
      name: "Bajaj Finserv",
      code: "BAJAJ",
      isDisplayOtp: false,
      isNoCostEMI: true,
      min_amount: environment.Bajaj.min_amount,
      max_amount: environment.Bajaj.max_amount,
      plans: []
    };
    bajajCreateCartOrderResp: any;
    showEmiTooltip: boolean = false;
    resendotp: boolean = false;
    counter;
    showWalnut369: boolean = false;
    isCardlessEmi: boolean = false;
  
    // paylater
    selectedPaylaterMethod: any;
    allowOpeningSimplewindow: boolean = true;
    simplEligibilityData: any;
    subcriptionPayment: any;
    ipAddress: any;
    simplWindow: any;
  
    partPayment:number;
    lastPartPaymentDate:any;
    discountPercentage: any;
    deviceWidth:any;


    constructor(
      public SubscriptionService: SubscriptionService,
      public router: Router,
      public spinner: NgxSpinnerService,
      public dialog: MatDialog,
      private zone: NgZone,
      private gaService: GAnalyticsService,
      private fb: FormBuilder,
      private http:HttpClient,
      public razorpayapiService: RazorpayapiService,
      private toastr: ToastrService,
      public markRef: ChangeDetectorRef,
      public userservice : UserService,
      public communicationMessageService : CommunicationMessageService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<TestRegistrationConfirmDialogComponent>,
      private dialogRef2: MatDialogRef<FestivalPaymentComponent>,
    ) { 
      this.selectedSubscriptionDetails = data?.paymentData;
      let payments = data?.paymentData;
      console.log(payments);
      this.subscriptionbillingUtility.selectedPackage =
        payments?.selectedPackage;
      this.subscriptionbillingUtility.selectedDuration =
        payments?.selectedDuration;
      this.subscriptionbillingUtility.selectedBatch = payments?.selectedBatch;
      this.selectedPartOptions = payments?.selectedPartOptions;
      this.pacakgeSelected = payments?.selectedPackage;
      this.courseSelected = payments?.courseSelected;
      this.selectedBatch = payments?.selectedBatch;
      this.validitySelected = payments?.selectedValidity;
      this.userDetails = payments?.userDetails;
    this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionDto?.amount;
    this.subscriptionbillingUtility.scoreId = payments?.ruleid;

    console.log(this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionList?.[0].componentsList)
    this.subscriptionbillingUtility.liveClassbatch =
    this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionList?.[0]?.componentsList.filter(
        (val) => val.producType?.toLowerCase() == 'liveclasses'
      );
    console.log(this.subscriptionbillingUtility.liveClassbatch)
    if (this.subscriptionbillingUtility.liveClassbatch?.length > 0) {
      this.subscriptionbillingUtility.selectedBatch = this.selectedBatch;
      this.subscriptionbillingUtility.courseSelected = this.courseSelected; 
      // this.subscriptionbillingUtility.today = new Date(
      //   this.selectedBatch?.startDate
      // );
      this.showPatialPaymentOptions(
        this.subscriptionbillingUtility?.selectedPackage?.id,
        this.subscriptionbillingUtility?.selectedPackage
          ?.packageSubscriptionList?.[0]?.id
      );
      this.subscriptionbillingUtility.selectedPackage.isScore = false;
    } else if (
      this.subscriptionbillingUtility.selectedPackage.productName
        .toLowerCase()
        .replace(/\s/g, '') == 'score'
    ) {
      this.subscriptionbillingUtility.selectedPackage.isScore = true;
      this.showPatialPaymentOptions(
        this.subscriptionbillingUtility?.selectedPackage?.id,
        this.validitySelected.id
      );
    } else {
      this.subscriptionbillingUtility.selectedValidity = this.validitySelected;
      this.showPatialPaymentOptions(
        this.subscriptionbillingUtility?.selectedPackage?.id,
        this.validitySelected.id
      );
      this.subscriptionbillingUtility.selectedPackage.isScore = false;
    }

    console.log(
      'this.subscriptionbillingUtility.selectedPackage: ',
      this.subscriptionbillingUtility.selectedPackage
    );
    this.subscriptionbillingUtility.selectedDuration = this.validitySelected;
    this.subscriptionbillingUtility.userDetails = this.userDetails;
    if ( this.subscriptionbillingUtility.selectedPackage.productName.toLowerCase() == 'starter') {
      this.subscriptionbillingUtility.selectedPackage.isStarter_Basic = false;
      this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList?.forEach(
        (val: any) => {
          this.subscriptionbillingUtility.today = new Date();
            let vDate = new Date(
              this.subscriptionbillingUtility.today.setMonth(
                this.subscriptionbillingUtility.today.getMonth() + val.numOfMonths
              )
            );
            val.validDate = new Date(vDate.setDate(vDate.getDate() - 1));
          
          val.amountpermonth = val.amount / val.numOfMonths;
        }
      );
    }

    this.subscriptionbillingUtility.stateName =
      this.subscriptionbillingUtility.states.find(
        (val) =>
          val.abbreviation == this.subscriptionbillingUtility?.userDetails?.state
      );
    if(this.selectedBatch?.id){
      this.subscriptionbillingUtility.discountCode = 'ILFESTJULY';
      this.applyDiscountCode();
    }
    }

  ngOnInit(): void {

    var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
    ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
    : {};
    this.userDetails = userDetails;
    this.subscriptionbillingUtility.userDetails = userDetails;

    console.log('this.subscriptionbillingUtility?.localUserData?: ', this.subscriptionbillingUtility?.localUserData);   
    this.createCardForm();
    // net banking search dropdown
    this.createBankForm();
    this.createUPIForm();
    this.createEMICardForm();
    this.createBajajEMICardForm();

    let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  
      key: environment.razorkey
    });
    rzp.once('ready', async (response) => {
      console.log(response)
      this.razorPayData = response;
      let bankDetails = response?.methods?.netbanking;
      let bankKeys = [];
      for (const key in bankDetails) {
        if (bankDetails.hasOwnProperty(key)) {
          bankKeys.push({ key });
          this.options.push({ name: bankDetails[key] });
          const index = this.popularBanksList.findIndex((bank) => bank.code==key);
          if(index != -1) {
            this.popularBanks.push(this.popularBanksList[index]);
          }
        }
      }
      this.popularBanks = this.popularBanksList.filter((bank) => bankKeys.findIndex(({ key }) => bank.code==key) != -1);
      let wallet = response?.methods?.wallet;
      for (const key in wallet) {
        if (wallet.hasOwnProperty(key)) {
          this.wallets.push({ name: key, code: key })
        }
      }
      let emi_options = response?.methods?.emi_options;
      this.emi_data = this.getEmiData(emi_options);
      this.checkVaildEmiData();
      this.checkWalnut369Exists();
    })
    this.getIPAddress();
  }


  getEmiData(emi_options: any) {
    let emi_data = [];
    for (const key in emi_options) {
      if (emi_options.hasOwnProperty(key)) {
        const val = emi_options[key];
        const emiPlan = {
          name: this.getEMIBankNameByCode(key),
          code: key,
          mode:
            key == 'HDFC' || key == 'HSBC'
              ? 'credit'
              : key == 'HDFC_DC'
              ? 'debit'
              : 'all',
          plans: val.map(x => {
            x.min_amount = x.min_amount/100;
            x.code = key;
            return x;
          }),
          isNoCostEMI: val.findIndex(x => x.interest==0)!=-1,
        };
        if(key != "onecard" && emiPlan.name != "None") {
          emi_data.push(emiPlan);
        }
      }
    }
    return emi_data;
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.deviceWidth = window.innerWidth;
  }

  getEMIBankNameByCode(code: any) {
    let bankName;
    switch(code) {
      case "AMEX":
        bankName = "American Express";
        break;
      case "BARB":
        bankName = "Bank of Baroda";
        break;
      case "CITI":
        bankName = "CITI Bank";
        break;
      case "HDFC":
        bankName = "HDFC Bank";
        break;
      case "HDFC_DC":
        bankName = "HDFC Bank";
        break;
      case "HSBC":
        bankName = "HSBC Bank";
        break;
      case "ICIC":
        bankName = "ICICI Bank";
        break;
      case "INDB":
        bankName = "Indusind Bank";
        break;
      case "KKBK":
        bankName = "Kotak Mahindra Bank";
        break;
      case "RATN":
        bankName = "RBL Bank";
        break;
      case "SCBL":
        bankName = "Standard Chartered Bank";
        break;
      case "UTIB":
        bankName = "Axis Bank";
        break;
      case "YESB":
        bankName = "Yes Bank";
        break;
      default:
        bankName = "None";
        break;
    }
    return bankName;
  }
  checkWalnut369Exists() {
    let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  
      key: environment.razorkey,
      amount: Math.round((this.subscriptionbillingUtility.emiPayLaterFulltotalAmount + Number.EPSILON) * 100)
    });
    rzp.once('ready', (response) => {
      this.showWalnut369 = Boolean(response?.methods?.cardless_emi?.["walnut369"]);
      this.markRef.detectChanges();
    })
  }

  
  showPatialPaymentOptions(PackageId, durationId) {
    console.log(durationId)
    this.subscriptionbillingUtility.partialPayment = [];
    this.SubscriptionService.getPartialPayments(PackageId, durationId).subscribe((res: any) => {
      console.log(res)
      res?.forEach((element, index) => {
        console.log(element.partPaymentPlanDetailsDto.length)
        if (element.partPaymentPlanDetailsDto.length == 1) {
          this.subscriptionbillingUtility.fullPayment = element;
        } else {
          this.subscriptionbillingUtility.partialPayment.push(element);
        }
      });

      this.subscriptionbillingUtility.partialPayment.sort((a, b) => {
        return (
          a.partPaymentPlanDetailsDto.length -
          b.partPaymentPlanDetailsDto.length
        );
      });

      this.calculateEmioptions();
    }),
      (error) => { };
  }

  applyDiscountCode() {
    this.spinner.show();

    let userDetails = this.SubscriptionService?.getuserDetails();
    let discode2 = {
      code: this.subscriptionbillingUtility.discountCode,
      grade: this.subscriptionbillingUtility.localUserData?.grade?.name?.replace(/[^0-9]/g, '') || userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
      userId: this.subscriptionbillingUtility.localUserData?.userId || userDetails?.userId
    };
    let CartItemId = localStorage.getItem('CartItemID');
    if (this.subscriptionbillingUtility.discountCode) {
      this.SubscriptionService.calulateDiscountForCartItemUsingGET(discode2).subscribe(
        (resp: any) => {
          if (resp) {
            let amount = resp?.discountForSubcriptionDtoList?.find(element=>element.id == CartItemId);
            this.subscriptionbillingUtility.discountAmount =
            amount?.discountValue;
            this.subscriptionbillingUtility.discountValid = 'valid';
            var payments = localStorage.getItem(apisDataCacheKeys.payments)
              ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
              : {};
            payments.discountCode = discode2.code;
            localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
            this.calculateEmioptions();
            if(this.customPaymntType == "emi") {
              this.checkVaildEmiData();
              this.checkWalnut369Exists();
            }
            if(this.customPaymntType == "pay_later") {
              this.checkSimpleEligibility("check_eligibility");
            }
            this.spinner.hide();
          } else {
            this.subscriptionbillingUtility.discountValid = 'error';
            this.subscriptionbillingUtility.discountCode = null;
            
            this.spinner.hide();
          }
        },
        (err) => {
          this.spinner.hide(); 
          this.subscriptionbillingUtility.discountValid = 'error';
          this.subscriptionbillingUtility.discountCode = null;         
         }
      );
    }
    // let discode = {
    //   code: this.subscriptionbillingUtility.discountCode,
    //   totalAmount: (this.subscriptionbillingUtility.liveClassbatch?.length > 0) ? (this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount) : this.subscriptionbillingUtility.selectedDuration?.amount,
    // };
    // if (this.subscriptionbillingUtility.discountCode) {
    //   this.SubscriptionService.validateDiscountCode(discode).subscribe(
    //     (resp: any) => {
    //       if (resp?.validDiscountCode) {
    //         this.subscriptionbillingUtility.discountAmount =
    //           resp?.discountAmount;
    //         this.subscriptionbillingUtility.discountValid = 'valid';
    //         var payments = localStorage.getItem(apisDataCacheKeys.payments)
    //           ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
    //           : {};
    //         payments.discountCode = discode.code;
    //         localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
    //         this.calculateEmioptions();
    //         if(this.customPaymntType == "emi") {
    //           this.checkVaildEmiData();
    //         }
    //         if(this.customPaymntType == "pay_later") {
    //           this.checkSimpleEligibility("check_eligibility");
    //         }
    //         this.spinner.hide();
    //       } else {
    //         this.subscriptionbillingUtility.discountValid = 'error';
    //         this.subscriptionbillingUtility.discountCode = null;
            
    //         this.spinner.hide();
    //       }
    //     },
    //     (err) => { }
    //   );
    // }
  }

  calculateEmioptions() {
    this.subscriptionbillingUtility.emiOptions = [];
    this.subscriptionbillingUtility.partialPayment.forEach(
      (partpaymentarray, indexval) => {
        let allEmiOptions = [];
        partpaymentarray?.partPaymentPlanDetailsDto?.forEach(
          (element, index, self) => {
            if (index !== 0) {
              element.amount =
                (((this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount) -
                  this.subscriptionbillingUtility?.discountAmount -
                  self?.[0]?.amount) *
                  element?.percentage) /
                100;
            }
            partpaymentarray.emiOptions = [];
            element.lastdate = new Date(this.subscriptionbillingUtility.today);
            element.lastdate.setDate(
              element.lastdate.getDate() + element?.daysLimit
            );
            allEmiOptions.push({ ...element });
          }
        );
        partpaymentarray.emiOptions = allEmiOptions;
      }
    );
    if(this.selectedPartOptions){
    let partOptions =  this.subscriptionbillingUtility?.partialPayment?.find(element=>element.name == this.selectedPartOptions?.name);
    this.selectedEmiInstalments(partOptions);
    } else {
      this.selectedEmiInstalments(
        this.subscriptionbillingUtility?.partialPayment?.[0]
      );
    } 
    console.log(this.subscriptionbillingUtility)
    let pfullpayment =
      this.subscriptionbillingUtility.fullPayment
        ?.partPaymentPlanDetailsDto?.[0];
    var fullamount = (this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility?.emiOptions?.[0]?.amount : (this.subscriptionbillingUtility.selectedDuration?.amount - this.subscriptionbillingUtility?.discountAmount));
        
    console.log('fullamoun: ', fullamount);

    let fullamountwithout = (this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount);
    this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = fullamountwithout - this.subscriptionbillingUtility?.discountAmount;
    console.log(this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount);
    if(!this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount && (this.customPaymntType=="emi" || this.customPaymntType == "pay_in_part" || this.customPaymntType == "pay_later" || this.paymentType == 'partpayment')){
      this.paymentType = "fullpayment";
      this.customPaymntTypeEvent("card");
    }
    if(this.customPaymntType == "pay_later") {
      this.checkSimpleEligibility("check_eligibility");
    }

    this.subscriptionbillingUtility.fullPaymentOptions = {
      ...pfullpayment,
      amount: fullamount,
    };
    console.log('this.subscriptionbillingUtility.fullPaymentOptions: ', this.subscriptionbillingUtility.fullPaymentOptions);

    console.log(this.subscriptionbillingUtility)
  }

  selectedEmiInstalments(selectedpartPaymentoption) {
    this.selectedPartOptions = selectedpartPaymentoption;
    this.subscriptionbillingUtility.emiOptions =
      selectedpartPaymentoption?.emiOptions;
      var payments = localStorage.getItem(apisDataCacheKeys.payments) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments)) : {};
      payments.selectedPartOptions = selectedpartPaymentoption;
      localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
  }

  removeAppliedCode() {
    this.spinner.show();
    this.subscriptionbillingUtility.discountValid = '';
    this.subscriptionbillingUtility.discountAmount = 0;
    this.subscriptionbillingUtility.discountCode = '';
    var payments = localStorage.getItem(apisDataCacheKeys.payments) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments)) : {};
    payments.discountCode = '';
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
    this.calculateEmioptions();
    if(this.customPaymntType == "emi") {
      this.checkVaildEmiData();
      this.checkWalnut369Exists();
    }
    if(this.customPaymntType == "pay_later") {
      this.checkSimpleEligibility("check_eligibility");
    }
    setTimeout(() => {
      this.spinner.hide()//intended spinner to add user good expeience
    }, 500)
  }

  blockStudentEnrollmentinliveClass() {
    var body = {
      student: this.subscriptionbillingUtility?.userDetails?.userId?.toString(),
      course: this.subscriptionbillingUtility?.courseSelected?.id,
      batch: this.subscriptionbillingUtility?.selectedBatch?.id,
    };
    console.log(body);
    this.spinner.show();
    this.SubscriptionService.blockCourseEnrollment(body).subscribe(
      
      (resp: any) => {
        console.log(resp)
        if (resp?.statusCode == 201) {
          this.spinner.hide();
          this.razorPayWindow();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err?.status == 400) {
          let dialogRef = this.dialog.open(
            TestRegistrationConfirmDialogComponent,
            {
              height: '280px',
              width: '500px',
              data: {
                message1: 'Oops!',
                message2: err?.error?.message,
              },
            }
          );
        }
      }
    );
  }

  payValue(amount, type) {
    console.log(amount);
    this.paymentValue = amount; //get payment value for button
    this.subscriptionbillingUtility.payValue = type;
    this.subscriptionbillingUtility.paidOptions = [];
    console.log(amount,type);
    console.log(this.subscriptionbillingUtility)
    if (type == 'fullpayment' && this.subscriptionbillingUtility?.selectedBatch?.id) {
      this.subscriptionbillingUtility.emiOptions.forEach((element, index) => {
        let fultimeDate = new Date(element.lastdate).setHours(23, 59, 59, 999);
        this.subscriptionbillingUtility.paidOptions.push({
          paidAmount: (index == 0 ? this.subscriptionbillingUtility?.fullPaymentOptions?.amount : 0).toFixed(2),
          applicableAmount: (element?.amount).toFixed(2),
          partPlanDetailsId: element.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD hh:mm:ss'),
          planName: element.name,
        });
      });
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Start',
        package_name: this.subscriptionbillingUtility?.selectedPackage?.name,
        subtotal: this.subscriptionbillingUtility?.fullPaymentOptions?.amount,
        grand_total: this.subscriptionbillingUtility?.fullPaymentOptions?.amount,
      });
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Part_Payment: type,
        Parts: this.subscriptionbillingUtility?.paidOptions?.length,
        amount: amount,
      });
    } else if(type == 'fullpayment') {
      let fultimeDate = new Date().setHours(23, 59, 59, 999);
      this.subscriptionbillingUtility.paidOptions = [
        {
          paidAmount:
          this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later' ? 
          this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount
          : this.subscriptionbillingUtility?.fullPaymentOptions?.amount?.toFixed(2),
          applicableAmount:
          this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later' ? 
          this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount
          : this.subscriptionbillingUtility?.fullPaymentOptions?.amount?.toFixed(2),
          partPlanDetailsId:
            this.subscriptionbillingUtility?.fullPaymentOptions?.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD HH:mm:ss'),
          planName: this.subscriptionbillingUtility?.fullPaymentOptions?.name,
        },
      ];
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Start',
        package_name: this.subscriptionbillingUtility?.selectedPackage?.name,
        subtotal: this.subscriptionbillingUtility?.selectedValidity?.amount,
        grand_total: this.subscriptionbillingUtility?.fullPaymentOptions?.amount,
      });
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Full_Payment: type,
        amount: amount,
      })
    } else {
      this.subscriptionbillingUtility.emiOptions.forEach((element, index) => {
        let fultimeDate = new Date(element.lastdate).setHours(23, 59, 59, 999);
        this.subscriptionbillingUtility.paidOptions.push({
          paidAmount: (index == 0 ? element.amount : 0).toFixed(2),
          applicableAmount: (element?.amount).toFixed(2),
          partPlanDetailsId: element.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD hh:mm:ss'),
          planName: element.name,
        });
      });
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Part_Payment: type,
        Parts: this.subscriptionbillingUtility?.paidOptions?.length,
        amount: amount,
      })
    }
    console.log(this.subscriptionbillingUtility.selectedBatch?.id);
    if (this.subscriptionbillingUtility.selectedBatch?.id) {
      console.log('blockstudent');
      this.blockStudentEnrollmentinliveClass();
    } else if (this.subscriptionbillingUtility.paidOptions?.length) {
      console.log('razpay');
      if(this.subscriptionbillingUtility?.scoreId){
        this.razorPayWindow();
    }else{
      this.checkSubscription();
    }
    } else {
    }
    // if (this.subscriptionbillingUtility.paidOptions?.length) {
    //   this.razorPayWindow();
    // }
  }

  checkSubscription() {
    var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
      ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
      : {};
    this.spinner.show();
    this.SubscriptionService.getPackagesSubscriptionByUserID({
      subscription_id: this.subscriptionbillingUtility?.selectedValidity?.id,
      user_id: userDetails?.userId,
    }).subscribe((resp: any) => {
      this.spinner.hide();
      if (resp) {
        let dialogRef = this.dialog.open(
          TestRegistrationConfirmDialogComponent,
          {
            height: '280px',
            width: '500px',
            data: {
              message1: 'Oops!',
              message2:
                'You are already enrolled to this package',
            },
          }
        );
      } else {
        this.spinner.hide();
        this.razorPayWindow();
      }
    });
  }

  razorPayWindow() {
    this.spinner.show();
    let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
    user = localStorage.getItem(apisDataCacheKeys.userDetails)
      ? JSON.parse(user)
      : {};
      var finalazorpayAmount =
      this.subscriptionbillingUtility.payValue == 'fullpayment'
        ? this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later'
          ? Math.round(
              (this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount +
                Number.EPSILON) *
                100
            ) / 100
          : Math.round(
              (this.subscriptionbillingUtility?.fullPaymentOptions?.amount +
                Number.EPSILON) *
                100
            ) / 100
        : Math.round((this.subscriptionbillingUtility?.emiOptions?.[0]?.amount + Number.EPSILON) * 100) / 100;

      var object: any = {
        amountAfterDiscount: this.subscriptionbillingUtility?.selectedBatch?.id ? (this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount - this.subscriptionbillingUtility?.discountAmount) : finalazorpayAmount,
        totalPaidAmount: finalazorpayAmount,
        batchId: this.subscriptionbillingUtility?.selectedBatch?.id ?? '',
        billingAddress: {
          address: this.subscriptionbillingUtility.userDetails?.address ?? '',
          email: this.subscriptionbillingUtility.userDetails.email ?? '',
          firstName: this.subscriptionbillingUtility.userDetails.firstName ?? '',
          lastName: this.subscriptionbillingUtility.userDetails.lastName ?? '',
          phone: this.subscriptionbillingUtility?.userDetails?.phone ?? '',
          statecode: this.subscriptionbillingUtility?.stateName?.abbreviation ?? '',
          zipcode: this.subscriptionbillingUtility?.userDetails?.pincode,
          stateName: this.subscriptionbillingUtility?.stateName?.name,
        },
        discountAmount: this.subscriptionbillingUtility?.discountAmount,
        discountCode: this.subscriptionbillingUtility.discountCode && this.subscriptionbillingUtility.discountValid == 'valid'
          ? this.subscriptionbillingUtility.discountCode
          : null,
        notes: '',
        orderAmount: (this.subscriptionbillingUtility.liveClassbatch?.length > 0
          ? this.subscriptionbillingUtility.selectedPackage
              ?.packageSubscriptionList[0]?.amount
          : this.subscriptionbillingUtility.selectedDuration?.amount
        ).toFixed(2),
        packageSubscriptions: [
          {
            id: this.subscriptionbillingUtility?.selectedDuration?.id
              ? this.subscriptionbillingUtility?.selectedDuration?.id
              : this.subscriptionbillingUtility?.selectedPackage
                  ?.packageSubscriptionList?.length == 1
              ? this.subscriptionbillingUtility?.selectedPackage
                  ?.packageSubscriptionList?.[0]?.id
              : '',
            paymentPlanCaptureDetailsDtoList:
              this.subscriptionbillingUtility.paidOptions,
            packageDealPriceAfterDiscount: this.subscriptionbillingUtility?.selectedBatch?.id ? (this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount - this.subscriptionbillingUtility?.discountAmount) : finalazorpayAmount,
            actual_amount: this.subscriptionbillingUtility.liveClassbatch?.length > 0
              ? this.subscriptionbillingUtility.selectedPackage
                  ?.packageSubscriptionList[0]?.amount
              : this.subscriptionbillingUtility.selectedDuration?.amount
            ,
            package_discount_code: this.subscriptionbillingUtility?.discountCode || "",
            package_discount_amount: (Math.round((this.subscriptionbillingUtility?.discountAmount + Number.EPSILON) * 100) / 100) || "",
            quantity: 1,
            courseId: this.subscriptionbillingUtility?.courseSelected?.id,
            batchId: this.subscriptionbillingUtility?.selectedBatch?.id,
            scoreId: null,
          },        
        ],
        isdCode: user?.isdCode ?? '',
        phone: user?.phone ?? '',
        payConditionDiscountAmount: '',
        payConditionDiscountper: '',
        paymentGatewayCode: this.paymentGatewayCode,
        userId: user?.userId,
        userOrderMasterId: 0,
        userOrderPaymentPlanCaptureDetailsId: 0,
        quantity: 1,
        unitPrice: finalazorpayAmount,
        renewed:
          this.subscriptionbillingUtility.selectedPackage?.renewed ?? false,
        extOrderId:
          this.subscriptionbillingUtility.selectedPackage?.extOrderId ?? 0,
        extDays: this.subscriptionbillingUtility.selectedPackage?.extDays ?? 0,
        grade: Number(localStorage.getItem('grade')),
        token: this.simplEligibilityData?.token,
        modeofPayment:
        this.customPaymntType === 'net_banking'
          ? 'netbanking'
          : this.customPaymntType === 'pay_later'
          ? 'paylater'
          : this.customPaymntType,
        emiPatner:
        this.customPaymntType === 'emi'
        ? this.selected_bank_emi_data.name
        : "",
        installmentAmount: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.amountForMonth?.toFixed(2) : 0,
        transactionAmount: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.amountForMonth.toFixed(2)*this.selectedEmiPlan?.duration : 0,
        noOfMonth: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.duration : "",
        payLatterPatner:
            this.customPaymntType === 'pay_later'
              ? this.paymentGatewayCode == 'RAZORPAY'
                ? this.selectedPaylaterMethod
                : 'SIMPL'
              : "",
        cardNo: 
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selctedBajajEMICardData?.cardNo
              : ''
            : undefined,
        bajajMobileNo:
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selctedBajajEMICardData?.phone
              : ''
            : undefined,
        tanure:
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selectedEmiPlan?.duration?.toString()
              : ''
            : undefined,
        ipAdd: this.bajajFinanceNoCostEmiData?.showBajaj ? this.ipAddress : undefined,
        schemeId: this.selectedEmiPlan?.schemeId,
        portal:"website",
        userPlatform: 'website'
      };
      if(this.paymentGatewayCode == "BAJAJFINANCE") {
        this.spinner.show();
      }
    this.SubscriptionService.createCartOrder(object).subscribe((resp: any) => {
      console.log(resp)
      this.subscriptionbillingUtility.generatedOrderDetails = resp;
      this.subscriptionbillingUtility.orderId = resp?.orderId;
      this.subscriptionbillingUtility.totalPaidAmount = finalazorpayAmount;
      let amount = object?.amountAfterDiscount * 100; //amountAfterDiscount for razor pay
      if (amount == 0 && this.subscriptionbillingUtility.discountCode) {
        this.subscriptionbillingUtility.selectedDuration.status = 'success';
        let planDetailsCapture = this.subscriptionbillingUtility?.paidOptions?.[0];
        this.dialogRef2.close();
        this.router.navigate(['./enroll-subscription/enroll-payementVerification'], {
          paidAmount: resp?.paidAmount,
          ...this.subscriptionbillingUtility.selectedPackage, 
          ...this.subscriptionbillingUtility.selectedDuration, 
          ...this.options, ...{ userOrderId: this.subscriptionbillingUtility.orderId },  
          ...{ planDetailsCapture: planDetailsCapture }, 
          ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
          ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet }
        });
        this.spinner.hide();
      } else {
        if(this.paymentGatewayCode == "RAZORPAY") {
          if(this.customPaymntType==="card") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.selctedCardData
            );
          } else if(this.customPaymntType==="net_banking") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, { method: "netbanking", bank: this.selectedBankName }
            );
          } else if(this.customPaymntType==="upi") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.upiMode=="QR" ? { method: "upi" } : { method: "upi", vpa: this.UPIControlForm.value.vpa }
            );
          } else if(this.customPaymntType==="wallet") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, { method: "wallet", wallet: this.selectedWalletCode }
            );
          } else if(this.customPaymntType==="emi") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.isCardlessEmi ? { method: "cardless_emi", provider: "walnut369" } : this.selctedEMICardData
            );
          } else if(this.customPaymntType==="pay_later") {
            if(this.selectedPaylaterMethod == "icic") {
              this.payUsingRazorPayCustomWebSDK(
                this.subscriptionbillingUtility, { method: "paylater", provider: "icic" }
              );
            }
          }
        } else if(this.paymentGatewayCode == "SIMPL") {
          const options = {
            name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
            amount: 100, // razorpay takes amount in paisa
            prefill: {
              name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
              email: this.subscriptionbillingUtility.userDetails?.email || 'sana.zohara@gmail.com', // add your email id
              contact: this.subscriptionbillingUtility.userDetails?.phone 
            },
          }
          if(resp?.simplTransactionResponse?.success) {
            this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, resp, options);
          } else {
            this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, resp, options);
          }
        } else if(this.paymentGatewayCode == "BAJAJFINANCE") {
          if(resp?.respCode == "0") {
            this.bajajCreateCartOrderResp = resp;
            this.bajajFinanceNoCostEmiData.isDisplayOtp = true;
            this.startCountdown(59);
          } else if(resp?.respDesc?.toLowerCase() == "NO RECORD FOUND FOR GIVEN MOBILE"?.toLowerCase() || resp?.respDesc?.toLowerCase() == "INVALID CARD NUMBER"?.toLowerCase()) {
            this.BajajEMICardErrorMSg = "Invalid Card/Mobile Number";
          } else if(resp?.respDesc?.toLowerCase() == "Card blocked for OTP entry, contact customer service"?.toLowerCase()) {
            this.BajajEMICardErrorMSg = "Card id blocked";
          } else if(resp?.respDesc?.toLowerCase() == "CARD NUMBER DOES NOT EXISTS"?.toLowerCase()) {
            this.BajajEMICardErrorMSg = "Card Number does not Exists!";
          } else if(resp?.respDesc?.toLowerCase() == "ERROR WHILE GENERATING OTP : MAX OTP LIMIT IS BREACHED. PLEASE RETRY AFTER 10 MINUTES"?.toLowerCase()) {
            this.BajajEMICardErrorMSg = "Max OTP limit is breached. Please retry after 10 minutes";
          }
          this.spinner.hide();
        }
      }
    }, (err: any) => {
      if(this.paymentGatewayCode == "BAJAJFINANCE") {
        this.spinner.hide();
      }
    });
  }
  payUsingRazorPayCustomWebSDK(subscriptionbillingUtility, selectedPaymentData) {
    console.log(subscriptionbillingUtility)
    console.log(selectedPaymentData)
    let finalazorpayAmount =
    this.subscriptionbillingUtility.payValue == 'fullpayment'
      ? this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later'
        ? Math.round(
            (this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount +
              Number.EPSILON) *
              100
          )
        : Math.round(
            (this.subscriptionbillingUtility?.fullPaymentOptions?.amount +
              Number.EPSILON) *
              100
          )
      : Math.round((this.subscriptionbillingUtility?.emiOptions?.[0]?.amount + Number.EPSILON) * 100);
    var paymentData = {
      amount: finalazorpayAmount, //pass in paise (amount: 100000 equals ₹1000)
      email: subscriptionbillingUtility.userDetails?.email || 'sana.zohara@gmail.com', 
      contact: subscriptionbillingUtility.userDetails?.phone ,
      "order_id": subscriptionbillingUtility.generatedOrderDetails.gatewayOrderId,
      description: 'Subscription',
      ...selectedPaymentData,
    };
    console.log(paymentData);
    const options = {
      name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
      amount: 100, // razorpay takes amount in paisa
      prefill: {
        name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
        email: this.subscriptionbillingUtility.userDetails?.email || 'sana.zohara@gmail.com', // add your email id
        contact: this.subscriptionbillingUtility.userDetails?.phone 
      },
    };
    let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  key: environment.razorkey });
    rzp.createPayment(paymentData)
    .on('payment.success', (response) => {
      this.paymentHandler(subscriptionbillingUtility, response, options);
      this.spinner.hide();
    })
    .on('payment.error', (error) => {
      console.log(error);
      if(this.subscriptionbillingUtility.payValue ==  'fullpayment') {
        subscriptionbillingUtility.selectedPaymentData = {...selectedPaymentData};
      } else {
        subscriptionbillingUtility.selectedPaymentData = {...selectedPaymentData, method: "pay_in_part", partPayment: this.partPayment};
      }
      this.onPaymentFailure(subscriptionbillingUtility,options);
      this.spinner.hide();
    })
    if(rzp?._payment?.popup == null) {
      this.spinner.hide();
    }
  }

  redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(subscriptionbillingUtility, createOrderResp, options) {
    this.subcriptionPayment = subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    if (!this.subcriptionPayment.selectedPackage) {
      this.subcriptionPayment.selectedPackage = { status: 'success' };
    } else {
      this.subcriptionPayment.selectedPackage.status = 'success';
    }
    const resp = this.paymentGatewayCode == "SIMPL" ? createOrderResp?.simplUserOrderPaymentResponse : createOrderResp;
    this.subcriptionPayment.paymentStatusCapture = resp;

    if (this.subscriptionbillingUtility?.courseSelected?.id) {
      let userDetails = this.SubscriptionService.getuserDetails();
      let body = {
        courses: this.subscriptionbillingUtility?.courseSelected?.id,
        batches: this.subscriptionbillingUtility?.selectedBatch?.id,
        student: {
          id:
            this.userDetails?.userId?.toString() ||
            userDetails?.userId?.toString(),
          firstName: this.userDetails?.firstName || userDetails?.firstName,
          lastName: this.userDetails?.lastName || userDetails?.lastName,
        },
        tenant: environment?.tenant,
        // gatewayOrderId: res?.razorpay_order_id,
        // razorpayPaymentId: res?.razorpay_payment_id,
        // razorpaySignature: res?.razorpay_signature,
      };
      this.spinner.hide();
    }
    // if(this.subscriptionSelectedData?.liveclass_courseID) {
    // this.spinner.show();
    this.dialogRef2.close();
    this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
                { ...this.subscriptionbillingUtility.selectedPackage, packageName: this.subscriptionbillingUtility?.selectedPackage?.name, ...this.subscriptionbillingUtility.selectedDuration, ...options, ...{ userOrderId: resp?.userOrder?.id }, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture }, ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet } })

    this.spinner.hide();

  }
  redirectToPaymentVerificationPageAfterSimplPaymentFailure(subscriptionbillingUtility, createOrderResp, options) {
    // add current page routing if payment fails
    subscriptionbillingUtility.selectedPaymentData = 
      this.paymentGatewayCode == "SIMPL" 
        ? { method: "paylater" }
        : { method: "emi" };
    this.subcriptionPayment = subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    if (!subscriptionbillingUtility.selectedPackage) {
      subscriptionbillingUtility.selectedPackage = {};
    }
    subscriptionbillingUtility.selectedPackage.status = 'error';
    $('#paymentfail').modal('show');
    //? checking cartcount
    
    // this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
    //           { ...subscriptionbillingUtility.selectedPackage, ...this.subscriptionbillingUtility.selectedDuration, ...this.options, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture }, ...{ paymentStatusCapture: subscriptionbillingUtility.paymentStatusCapture }, ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet }, ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData } });
    
    this.spinner.hide();
  }

  
  calculatePaymentOptions(emitype, totalData) {

    this.subscriptionbillingUtility.selectedCartItems = totalData?.map((cartItem) => {
      var findIndex_partPayment = cartItem?.partPaymentPlanMasterDtoList?.findIndex((installmentList) => installmentList?.partPaymentPlanDetailsDto.length == emitype);
      cartItem.selectedPartPaymentPlanMasterDtoList = [];
      if (findIndex_partPayment != -1) {
        cartItem.selectedPartPaymentPlanMasterDtoList = [cartItem?.partPaymentPlanMasterDtoList[findIndex_partPayment]]
        let maxDaysLimit = Math.max(
          ...(cartItem?.partPaymentPlanMasterDtoList[findIndex_partPayment]
            ?.partPaymentPlanDetailsDto?.map((part) => part?.daysLimit) ?? [])
        );
        this.lastPartPaymentDate = moment()
          .add(maxDaysLimit, 'days')
          .set('hour', 23)
          .set('minute', 59)
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (findIndex_partPayment == -1 && cartItem?.partPaymentPlanMasterDtoList?.length) {
        cartItem.selectedPartPaymentPlanMasterDtoList = [cartItem?.partPaymentPlanMasterDtoList[0]]
      }
      return cartItem
    })?.filter((v) => v?.selectedPartPaymentPlanMasterDtoList?.length)
    
    let fullpaymentsAmount =  this.subscriptionbillingUtility.selectedCartItems.reduce( (a,v )=>{
     a.push(...(v.partPaymentPlanMasterDtoList?.find(innv=>innv?.partPaymentPlanDetailsDto?.length == 1).partPaymentPlanDetailsDto) )
    return a},[]) 
    let maxPercentage = Math.max(...fullpaymentsAmount.map(v=>v.discountPer));
    this.discountPercentage = maxPercentage
    this.subscriptionbillingUtility.partPaymentDiscountper = maxPercentage;
    this.subscriptionbillingUtility.totalAmount_withoutdiscount  =   this.subscriptionbillingUtility.allCartItems.reduce((a,v)=>{
    a= a +(v?.subscription?.amount * v.quantity)
    return a },0)
     this.subscriptionbillingUtility.fulltotalAmount = this.subscriptionbillingUtility.totalAmount_withoutdiscount*((100-maxPercentage)/100) 
     this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = this.subscriptionbillingUtility.totalAmount_withoutdiscount;
    this.totalPartPaymentAmt = this.subscriptionbillingUtility.selectedCartItems.reduce((acc,v)=>{
      acc = acc  + v.selectedPartPaymentPlanMasterDtoList[0]?.partPaymentPlanDetailsDto[0]?.applicableAmount
      return acc
    },0)
    if(this.customPaymntType == "emi") {
      this.checkVaildEmiData();
      this.checkWalnut369Exists();
    }
  }

  payInparts(emitype, totalData,data:any = {}) {
    this.partPayment=emitype;
    this.subscriptionbillingUtility.selectedEmiPart = emitype;
    if (this.subscriptionbillingUtility.discountCode) {
      this.applyDiscountCode()
    } else {
      this.calculatePaymentOptions(emitype, totalData)
    }
  }
  openPartapayBtn() {
    this.openPartapaystatus = !this.openPartapaystatus;
  }

  paymentHandler(subscriptionbillingUtility: any, res: any, options: any) {
    console.log(subscriptionbillingUtility);
    let emiData = this.subscriptionbillingUtility.paidOptions;
    let planDetailsCapture = this.subscriptionbillingUtility?.paidOptions?.[0];
    this.zone.run(() => {
      if (res?.razorpay_signature) {
        var obj = {
          "gatewayCode": "RAZORPAY",
          "paymentMode": "ONLINE",
          "razorpayOrderId": res?.razorpay_order_id,
          "razorpayPaymentId": res?.razorpay_payment_id,
          "razorpaySignature": res?.razorpay_signature,
          "userOrderId": this.subscriptionbillingUtility.orderId,
          "batchId": this.subscriptionbillingUtility?.selectedBatch?.id ?? '',
          "ruleID": this.subscriptionbillingUtility.selectedPackage?.id ?? '',
          "userOrderPaymentPlanCaptureDetailsRequest": this.subscriptionbillingUtility.payValue == 'fullpayment' ?
            [{
              "paidAmount": this.subscriptionbillingUtility.fullPaymentOptions?.amount,
              "partAmount": this.subscriptionbillingUtility.fullPaymentOptions?.amount,
              "partPlanDetailsId": this.subscriptionbillingUtility.fullPaymentOptions?.planDetailId
            }]
            : this.subscriptionbillingUtility.emiOptions?.map((val, index) => {
              return {
                "paidAmount": index == 0 ? val?.amount : 0,
                "partAmount": val?.amount,
                "partPlanDetailsId": val?.planDetailId
              }
            }) ?? [],
          "paymentPlanCaptureDetailsId": this.subscriptionbillingUtility.payValue == 'fullpayment' ? this.subscriptionbillingUtility.fullPaymentOptions?.planDetailId : this.subscriptionbillingUtility.emiOptions?.[0]?.planDetailId,
          "portal":"website"
        }
        this.SubscriptionService.userPayment(obj).subscribe((resp: any) => {
          let scoreRegisterDetails;
          this.subscriptionbillingUtility.selectedPackage.status = 'success';
          this.subscriptionbillingUtility.paymentStatusCapture = resp;
          if (this.subscriptionbillingUtility?.scoreId) {
            this.spinner.show();
            let body1 = {
              ruleid: this.subscriptionbillingUtility?.scoreId,
            };
            this.SubscriptionService.getTimeSlotData(body1).subscribe(
              (res: any) => {
                this.spinner.show();
                console.log(res);
                scoreRegisterDetails = res?.[0]?.span;
              this.subscriptionbillingUtility.scoreDetails = res?.[0];              
                var findrelatedId = res?.find((v) => v._id == body1?.ruleid);
                this.subscriptionbillingUtility.scoreDate = findrelatedId?.span
                  ? new Date(findrelatedId?.span)
                  : '';
                  let body2 = {
                    rules: [
                      {
                        ruleid: this.subscriptionbillingUtility?.scoreDetails?._id,
                        span: this.subscriptionbillingUtility?.scoreDetails?.span,
                        isoffline: false,
                        state: this.subscriptionbillingUtility?.stateName?.name,
                        city: '',
                        center: '',
                      },
                    ],
                    studentid: this.subscriptionbillingUtility?.userDetails?.phone,
                    isActive: 'true',
                  };
          
                  this.SubscriptionService.registerExamSchedule(body2).subscribe(
                    (res) => {
                  
                  this.spinner.hide();
                  this.dialogRef2.close();
                  setTimeout(()=>{
                    this.router.navigate(['/diagnostic-test/thankyou'],
                    { ...this.subscriptionbillingUtility?.selectedPackage, 
                      packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
                      ...this.subscriptionbillingUtility.selectedDuration, 
                      ...this.options, 
                      ...{ userOrderId: obj?.userOrderId }, 
                      ...{ emiData: emiData }, 
                      ...{ planDetailsCapture: planDetailsCapture }, 
                      ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                      ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet },
                      scoreRegisterDetails: scoreRegisterDetails});
                  }, 2000);
                  let phoneAndName = this.userservice.getMobileAndName();
                  let examstart = moment(this.subscriptionbillingUtility?.scoreDetails?.span, "YYYY-MM-DD hh:mm A").format("DD/MM/YYYY hh:mm A");
                  let examendDateTime = moment(examstart,'DD/MM/YYYY hh:mm A').add(parseInt(this.subscriptionbillingUtility?.scoreDetails?.duration), 'minutes').format('DD/MM/YYYY hh:mm A');
                  if (phoneAndName && phoneAndName.phone) {
                    let body:any={
                      "applicationLink": 'https://test.infinitylearn.com'+'/',
                      "liveDCLink": 'https://test.infinitylearn.com'+'/',
                      "name": phoneAndName.firstName+" "+phoneAndName.lastName,
                      "phonenumber":phoneAndName.phone,
                      "resultlink": 'https://test.infinitylearn.com'+'/',
                      "span": examstart,
                      "testEndTime": examendDateTime,
                      "testName": this.subscriptionbillingUtility?.scoreDetails?.rulename
                    }
                    this.communicationMessageService.multiRegistrationMessage(body).subscribe(()=>{})
                  }
                  })
                this.spinner.hide();
              }
            );
    
            
          }
          else {
            //   if(this.isScoreExam){
            //     this.registerScoreObj()
            //     // this.routingUrl = './subscription/paymentresult'
            //   }
            //   this.router.navigate([this.routingUrl],
            //   { ...this.subscriptionbillingUtility.selectedPackage, ...this.options, ...{ userOrderId: obj?.userOrderId } ,
            //   ...{selectedExamDate:this.subscriptionbillingUtility?.selectedExamDate,selectedExamTime:this.subscriptionbillingUtility?.selectedExamTime}})
            this.spinner.hide();
            this.dialogRef2.close();
            this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
              { ...this.subscriptionbillingUtility?.selectedPackage, 
                packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
                ...this.subscriptionbillingUtility.selectedDuration, 
                ...this.options, 
                ...{ userOrderId: obj?.userOrderId }, 
                ...{ emiData: emiData }, 
                ...{ planDetailsCapture: planDetailsCapture }, 
                ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet } });
          }
          // }


        })
      }
    });
  }

  // custom payment event start
customPaymntTypeEvent(event){
  //console.log(event);
  this.customPaymntType = event;
  this.customPaymntPanelStatus = true;
  this.innerPanelName = '';
  if(event == "emi") {
    this.checkVaildEmiData();
    this.checkWalnut369Exists();
  } else if(event == "pay_later") {
    this.checkSimpleEligibility("check_eligibility");
  }
}
customPaymntPanelClose(){
  this.customPaymntPanelStatus = false;
}

toggleInnerPanel(getInnerPanelName){
  this.innerPanelName = getInnerPanelName;
}

// pay using razorpay for card, netbanking, upi, wallet
makePayment() {
  this.paymentGatewayCode = 'RAZORPAY';
  if(this.paymentType == "fullpayment") {
    this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
  } else {
    console.log((this.subscriptionbillingUtility.emiOptions?.length)?(this.subscriptionbillingUtility.emiOptions[0].amount):0)
    this.payValue((this.subscriptionbillingUtility.emiOptions?.length)?(this.subscriptionbillingUtility.emiOptions[0].amount):0,'partpayment')
  }
}

get newCard() { return this.newCardForm.controls}

addCard() {
  console.log(this.newCardForm);
  this.selctedCardData = {
    method: "card",
    "card[name]": this.newCardForm.value.card_placeholder_name,
    "card[number]": this.newCardForm.value.card_number,
    "card[expiry]": this.newCardForm.value.expiry,
    "card[cvv]": this.newCardForm.value.cvv,
  }
  this.makePayment();
}

createCardForm() {
  this.newCardForm = this.fb.group({
    card_placeholder_name: new FormControl('', [Validators.required,  Validators.pattern('^((?:[A-Za-z]+ ?){1,3})$')]),
    card_number: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{13,19}$')]),
    expiry: new FormControl('',[Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\/([0-9]{2})$'), this.checkCardExpiry()]),
    cvv: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{3,4}$')]),
  })
}

checkCardExpiry(): ValidatorFn {
  return (control: AbstractControl) => {
    const val = control.value;
    let month_year = val?.split("/");
    const month = month_year?.[0];
    const year = month_year?.[1];
    const curYearLastTwoDigits = new Date().getFullYear().toString().substr(-2);
    const curMonth = new Date().getMonth()+1;
    const isValid = (year && (Number(year) > Number(curYearLastTwoDigits))) || (year && (Number(year) == Number(curYearLastTwoDigits)) && (Number(month) >= Number(curMonth)));
    return isValid ? null:  {'cardExpiryCheck': true};
  };
}

dateKeyPress(e) {
  return e.charCode >= 48 && e.charCode <= 57;
}

addSlash(e) {
  if(e.target.value?.length == 1 && e.target.value>=2 && e.target.value<=9) {
    e.target.value = "0" + e.target.value;
  }
  if (
    e.target.value == '/' ||
    /^\d\/$/.exec(e.target.value) ||
    /^\d\d\/\/$/.exec(e.target.value) ||
    /^\d\d\/\d\/$/.exec(e.target.value)
  ) {
    e.target.value = e.target.value.slice(0, -1);
  }
  console.log(e)
  var monthRegex= /^\d\d$/;
  var isMonthEntered = monthRegex.exec(e.target.value);
  if (e.key >= 0 && e.key <= 9 && isMonthEntered) {
    e.target.value = e.target.value + "/";
  }
};

removeSlash(e) {
  var monthAndSlashRegex = /^\d\d\/$/;
  var isMonthAndSlashEntered = monthAndSlashRegex.exec(e.target.value);
  if (isMonthAndSlashEntered && e.key === 'Backspace') {
    e.target.value = e.target.value.slice(0, -1);
  }
};

createBankForm() {
  this.bankControlForm = this.fb.group({
    bankName: new FormControl('', [this.checkIsBankName()]),
  });
  this.filteredOptions = this.bankControlForm.get('bankName')!.valueChanges.pipe(
    startWith(''),
    map(value => (typeof value === 'string' ? value : value.name)),
    map(name => (name ? this._filter(name) : this.options.slice())),
  );
}

checkIsBankName(): ValidatorFn {
  return (control: AbstractControl) => {
    const val = typeof control.value === 'string' ? control.value : control.value?.name;
    const isValid = val == "" || this.options.findIndex((bank) => bank.name === val) != -1;
    return isValid ? null:  {'bankNameCheck': isValid};
  };
}

selectedBank(bankCode: any) {
  this.createBankForm()
  this.selectedBankName = bankCode;
}

payUsingNetBank() {
  if(!this.selectedBankName) {
    let bankName = this.bankControlForm.value.bankName?.name;
    let bankDetails = this.razorPayData?.methods?.netbanking;
    for (const key in bankDetails) {
      if (bankDetails.hasOwnProperty(key)) {
        if(bankName == bankDetails[key]) {
          this.selectedBankName = key;
        }
      }
    }
  }
  this.makePayment();
}

createUPIForm() {
  this.UPIControlForm = this.fb.group({
    vpa: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$')]),
  });
  this.UPIControlForm.get('vpa')!.valueChanges.subscribe((value) => {
    this.isUPIVerified=false;
    this.isUPIValid=false;
  })
}

checkIsUPICorrect() {
  const payload = {
    entity: "vpa",
    value: this.UPIControlForm.value.vpa
  }
  this.upicheckLoading = true;
  this.SubscriptionService.checkIsUPICorrect(payload).subscribe((response) => {
    console.log(response)
    if(response?.success) {
      this.isUPIValid = true;
    } else {
      this.isUPIValid = false;
    }
    this.upicheckLoading = false;
  }, (err) => {
    this.isUPIValid = false;
    this.upicheckLoading = false;
  })
  this.isUPIVerified = true;
}

payUsingUPI(upimode: any) {
  this.upiMode = upimode;
  this.makePayment();
}

// wallet
selectedWallet(walletCode: any) {
  this.selectedWalletCode = walletCode;
}

payUsingWallet() {
  this.makePayment();
}

// emi
checkVaildEmiData() {
  this.spinner.show();
  this.validEmiData = this.emi_data
    .filter(x => x.plans.filter(y => this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount > y.min_amount)?.length>0);
  this.hasDebitCardEMI = this.validEmiData.filter(x => x.mode=='all' || x.mode=='debit').length;
  this.hasCreditCardEMI = this.validEmiData.filter(x => x.mode=='all' || x.mode=='credit').length;
  this.spinner.hide();
}

setSelectedbankEMIData(panelName:any, bankEMIData: any, mode: any) {
  console.log(this.subscriptionbillingUtility.emiPayLaterFulltotalAmount);
  console.log(this.subscriptionbillingUtility?.fullPaymentOptions?.amount);
  this.toggleInnerPanel(panelName);
  console.log(bankEMIData)
  let tempBankEMIData = {...bankEMIData};
  if(mode == "credit" || mode =="debit") {
    tempBankEMIData.plans.sort((plan_a, plan_b) => plan_a.duration-plan_b.duration)
      .map((plan) => {
        // emi amount for month formulae is p*r*(1+r)**n/((1+r)**n - 1)
        let p = this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount; // principal amount
        let r = plan.interest/(12*100); // interest per month
        let n = plan.duration; // months
        plan.amountForMonth = plan.interest==0 ? this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount/n : p*r*(1+r)**n/((1+r)**n - 1);
        plan.noCostEmiDiscount = 0;
        return plan;
      });
  } else {
    const bajajPlans = this.getBajajDuratios();
    tempBankEMIData.plans = [];
    bajajPlans.map((bajajPlan) => {
      let p = this.subscriptionbillingUtility.emiPayLaterFulltotalAmount; // principal amount
      let r = 15/(12*100); // interest per month
      let n = bajajPlan?.tenor; // months
      tempBankEMIData.plans.push({
        interest: 0,
        min_amount: environment.Bajaj.min_amount,
        "duration": bajajPlan?.tenor,
        "schemeId": bajajPlan?.schemeId,
        code: "BAJAJ",
        amountForMonth: p/n,
        noCostEmiDiscount: n*p*r*(1+r)**n/((1+r)**n - 1) - p
      })
    })
  }
  console.log(tempBankEMIData);
  this.selected_bank_emi_data = tempBankEMIData;
  this.emiMode = mode;
}

getBajajDuratios() {
  return environment.Bajaj.Durations.map((scheme) => {
    return { tenor: scheme?.tenor, schemeId: scheme?.schemeId };
  })
}

setSelectedEMIPlan(panelName: any, plan: any, index: any) {
  this.toggleInnerPanel(panelName);
  this.selectedEmiPlan = {...plan, index};
  if(plan?.code == "BAJAJ") {
    this.createBajajEMICardForm();
    this.bajajFinanceNoCostEmiData.isDisplayOtp = false;
  }
}

createEMICardForm() {
  this.EMICardForm = this.fb.group({
    card_placeholder_name: new FormControl('', [Validators.required,  Validators.pattern('^((?:[A-Za-z]+ ?){1,3})$')]),
    card_number: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{13,19}$')]),
    expiry: new FormControl('',[Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\/([0-9]{2})$'), this.checkCardExpiry()]),
    cvv: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{3,4}$')]),
  })
  this.EMICardForm.get("card_number")!.valueChanges.subscribe((value) => {
    this.EMICardErrorMSg = "";
  })
}
createBajajEMICardForm() {
  this.BajajEMICardForm = this.fb.group({
    card_number: new FormControl('',[Validators.required, Validators.pattern('^([0-9]{13,19}|[6-9][0-9]{9})$')]),
    bajajOtp: new FormControl('',[Validators.required, Validators.pattern('^([0-9]{6})$')]),
  });
  this.BajajEMICardForm.get("card_number")!.valueChanges.subscribe((value) => {
    this.BajajEMICardErrorMSg = "";
  });
  this.BajajEMICardForm.get("bajajOtp")!.valueChanges.subscribe((value) => {
    this.BajajEMIOtpErrorMSg = "";
  });
}
createOrderAndGetOtpWithBajajNoCostEMI() {
  this.paymentGatewayCode = "BAJAJFINANCE";
  this.selctedBajajEMICardData = {
    phone: this.BajajEMICardForm.value.card_number.length == 10 ? this.BajajEMICardForm.value.card_number : "",
    cardNo: this.BajajEMICardForm.value.card_number.length > 10 ? this.BajajEMICardForm.value.card_number : "",
    otp: "",
  }
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}
resendBajajOtp() {
  const payload = {
    bajajMobileNo: this.selctedBajajEMICardData?.phone,
    cardNo: this.selctedBajajEMICardData?.cardNo,
    ipAdd: this.ipAddress,
    orderId: this.bajajCreateCartOrderResp?.orderId,
    tanure: this.selectedEmiPlan?.duration?.toString(),
    schemeId: this.selectedEmiPlan?.schemeId
  }
  this.SubscriptionService.resendBjajOtp(payload).subscribe((resp: any) => {
    this.subscriptionbillingUtility.generatedOrderDetails = resp;
    if(resp?.respCode == "0") {
      this.resendotp = false;
      this.bajajCreateCartOrderResp = resp;
      this.bajajFinanceNoCostEmiData.isDisplayOtp = true;
      this.BajajEMICardErrorMSg = "";
      this.startCountdown(59);
    } else if(resp?.respDesc?.toLowerCase() == "NO RECORD FOUND FOR GIVEN MOBILE"?.toLowerCase() || resp?.respDesc?.toLowerCase() == "INVALID CARD NUMBER"?.toLowerCase()) {
      this.BajajEMICardErrorMSg = "Invalid Card/Mobile Number";
    } else if(resp?.respDesc?.toLowerCase() == "Card blocked for OTP entry, contact customer service"?.toLowerCase()) {
      this.BajajEMICardErrorMSg = "Card id blocked";
    } else if(resp?.respDesc?.toLowerCase() == "CARD NUMBER DOES NOT EXISTS"?.toLowerCase()) {
      this.BajajEMICardErrorMSg = "Card Number does not Exists!";
    } else if(resp?.respDesc?.toLowerCase() == "ERROR WHILE GENERATING OTP : MAX OTP LIMIT IS BREACHED. PLEASE RETRY AFTER 10 MINUTES"?.toLowerCase()) {
      this.BajajEMICardErrorMSg = "Max OTP limit is breached. Please retry after 10 minutes";
    }
  })
}

startCountdown(seconds) {
  this.counter = seconds;
  const interval = setInterval(() => {
    this.counter--;
    if (this.counter == 0) {
      this.resendotp = true;
      clearInterval(interval);
    }
  }, 1000);
}

payUsingBajajNoCostEMI() {
  this.paymentGatewayCode = "BAJAJFINANCE";
  this.selctedBajajEMICardData = {
    phone: this.BajajEMICardForm.value.card_number.length == 10 ? this.BajajEMICardForm.value.card_number : "",
    cardNo: this.BajajEMICardForm.value.card_number.length > 10 ? this.BajajEMICardForm.value.card_number : "",
    otp: this.BajajEMICardForm.value.bajajOtp,
  }
  this.payUsingBajajWithOTP();
}
conv_number(expr, decplaces) {
  var str = "" + Math.round(eval(expr) * Math.pow(10,decplaces));
  while (str.length <= decplaces) {
    str = "0" + str;
  }

  var decpoint = str.length - decplaces;
  return (str.substring(0,decpoint) + "." + str.substring(decpoint,str.length));
}

// Parameters are rate, total number of periods, payment made each period and future value
pv(rate, nper, pmt, fv) {
  let pv_value;
  rate = parseFloat(rate);
  nper = parseFloat(nper);
  pmt = parseFloat(pmt);
  fv = parseFloat(fv);
  if ( nper == 0 ) {
    alert("Why do you want to test me with zeros?");
    return(0);       
  }
  if ( rate == 0 ) { // Interest rate is 0
    pv_value = -(fv + (pmt * nper));
  } else {
    let x = Math.pow(1 + rate, -nper); 
    let y = Math.pow(1 + rate, nper);
    pv_value = - ( x * ( fv * rate - pmt + y * pmt )) / rate;
  }
  pv_value = this.conv_number(pv_value, 2);
  return (pv_value);
}
// part payment
payUsingEMI() {
  console.log(this.EMICardForm);
  this.selctedEMICardData = {
    method: "emi",
    "card[name]": this.EMICardForm.value.card_placeholder_name,
    "card[number]": this.EMICardForm.value.card_number,
    "card[expiry]": this.EMICardForm.value.expiry,
    "card[cvv]": this.EMICardForm.value.cvv,
    emi_duration: this.selectedEmiPlan?.duration,
    // offer id for No Cost EMI
    offer_id: this.selectedEmiPlan?.offer_id
  }
  console.log(this.selctedEMICardData)
  // this.makePayment();
  this.SubscriptionService.checkIsEmiCardCorrect(this.EMICardForm.value.card_number.toString().slice(0, 6))
    .subscribe((response) => {
      const carddata = response;
      if (
        this.selected_bank_emi_data?.code
          ?.toLowerCase()
          .includes(carddata?.issuer?.toLowerCase()) &&
        carddata?.type == this.emiMode
      ) {
        this.isCardlessEmi = false;
        this.makePayment();
      } else {
        this.EMICardErrorMSg = `Please enter ${this.selected_bank_emi_data.name} ${this.emiMode=="credit" ? "Credit" : this.emiMode=="debit" ? "Debit" : ""} card`;
      }
    }, (error) => {
      this.EMICardErrorMSg = `Please enter ${this.selected_bank_emi_data.name} ${this.emiMode=="credit" ? "Credit" : this.emiMode=="debit" ? "Debit" : ""} card`;
    })
}

payUsingWalnut369() {
  this.isCardlessEmi = true;
  this.selected_bank_emi_data = {
    name: "walnut369",
  }
  this.selectedEmiPlan = {
    amountForMonth: 0,
    duration: 0,
  }
  this.makePayment();
}


displayTooltip() {
  if(this.deviceWidth<=992) {
    this.showEmiTooltip = true;
  }
}

closeTooltip() {
  if(this.deviceWidth<=992) {
    this.showEmiTooltip = false;
  }
}
// part payment 

doPartPayment() {
  this.paymentType = "partpayment";
  this.customPaymntType= "card";
  this.customPaymntPanelClose();
}

goToPayInPartsMenu() {
  this.paymentType = "fullpayment";
  this.customPaymntTypeEvent("pay_in_part");
}

// paylater

payLaterUsingICICI(method) {
  this.paymentGatewayCode = 'RAZORPAY';
  this.selectedPaylaterMethod = method;
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}

getIPAddress() {
  this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
    this.ipAddress = res.ip;
  });
}

checkSimpleEligibility(type: any) {
  let userData = JSON.parse(
    localStorage.getItem(apisDataCacheKeys.userDetails)
  );
  const payload = {
    amount_in_paise: Math.round((this.subscriptionbillingUtility.emiPayLaterFulltotalAmount + Number.EPSILON) * 100),
    phone_number: userData.phone,
    device_params: {
      "simpl_ipa": this.ipAddress, 
      // 'SIMPL-AdId': '',
      // 'SIMPL-DEVICE-MANUFACTURER': '',
      // 'SIMPL-DEVICE-MODEL': '',
      // 'SIMPL-isR': '',
      // 'SIMPL-AndId': '',
      // 'SIMPL-IPA': '',
      // 'SIMPL-PAV': '',
      // 'SIMPL-InApp': '',
      // 'SIMPL-Ltln': '',
    },
  };
  this.SubscriptionService.checkUserSimpleEligibility(payload).subscribe((response: any) => {
    this.simplEligibilityData = response?.data;
    if (type == 'linking_required') {
      if(this.simplEligibilityData?.error_code != 'linking_required') {
        this.toastr.success('Simpl linked, click on Simpl to pay with Simpl');
      }
    } else if(
      type == 'insufficient_credit' ||
      type == 'pending_dues'
    ) {
      if(this.simplEligibilityData?.error_code == null && this.simplEligibilityData?.token) {
        this.createOrderAndPayUsingSimple();
      }
    }
  }, (err) => {
    console.log(err);
    this.simplEligibilityData = {
      error_code: "unable_to_process",
      status: "not_eligible"
     };
  });
}

payUsingSimpl() {
  if (
    this.simplEligibilityData?.error_code == 'linking_required' ||
    this.simplEligibilityData?.error_code == 'insufficient_credit' ||
    this.simplEligibilityData?.error_code == 'pending_dues'
  ) {
    this.spinner.show();
    this.openSimplWindow(this.simplEligibilityData?.error_code);
  } else if(this.simplEligibilityData?.error_code == null && this.simplEligibilityData?.token) {
    this.createOrderAndPayUsingSimple();
  }
}

openSimplWindow(errorCode: any) {
  if(this.allowOpeningSimplewindow) {
    this.simplWindow = window.open(
      this.simplEligibilityData?.redirection_url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=600'
    );
    this.allowOpeningSimplewindow = false;
    var timer = setInterval(() => {
      if (this.simplWindow?.closed) {
        this.allowOpeningSimplewindow = true;
        console.log(this.simplWindow);
        clearInterval(timer);
        this.spinner.hide();
        this.checkSimpleEligibility(errorCode);
      }
    }, 1000);
  } else {
    this.simplWindow.focus();
  }
}

createOrderAndPayUsingSimple() {
  this.spinner.show();
  this.paymentGatewayCode = 'SIMPL';
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}

// custom payment event ended


// net banking search dropdown start
  displayFn(bankname: Bank): string {
    return bankname && bankname.name ? bankname.name : '';
  }
  private _filter(name: string): Bank[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
// net banking search dropdown ended

payUsingBajajWithOTP() {
  this.spinner.show();
  this.subcriptionPayment = this.subscriptionbillingUtility;
  var obj = {
    "gatewayCode": this.paymentGatewayCode,
    "paymentMode": "ONLINE",
    "razorpayOrderId": "",
    "razorpayPaymentId": "",
    "razorpaySignature": "",
    "userOrderId": this.subcriptionPayment.orderId,
    "batchId": this.subcriptionPayment?.selectedBatch?.id ?? '',
    "ruleID": this.subcriptionPayment.selectedPackage?.id ?? '',
    "userOrderPaymentPlanCaptureDetailsRequest": this.subcriptionPayment.payValue == 'fullpayment' ?
      [{
        "paidAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
        "partAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
        "partPlanDetailsId": this.subcriptionPayment.fullPaymentOptions?.planDetailId
      }]
      : this.subcriptionPayment.emiOptions?.map((val, index) => {
        return {
          "paidAmount": index == 0 ? val?.amount : 0,
          "partAmount": val?.amount,
          "partPlanDetailsId": val?.planDetailId
        }
      }) ?? [],
    "paymentPlanCaptureDetailsId": this.subcriptionPayment.payValue == 'fullpayment' ? this.subcriptionPayment.fullPaymentOptions?.planDetailId : this.subcriptionPayment.emiOptions?.[0]?.planDetailId,
    "bajajFinanaceDto": {
      "cardNumber": this.selctedBajajEMICardData?.cardNo,
      "ipAdd": this.ipAddress,
      "mobileNo": this.selctedBajajEMICardData?.phone,
      "nameOnCard": this.subcriptionPayment.userDetails.firstName + ' ' + this.subcriptionPayment.userDetails.lastName,
      "otp": this.selctedBajajEMICardData?.otp,
      "requestId": this.bajajCreateCartOrderResp?.requestId,
      "tanure": this.selectedEmiPlan?.duration?.toString(),
      "schemeId": this.selectedEmiPlan?.schemeId
    },
  }
  this.SubscriptionService.userPayment(obj).subscribe({
    next: (resp: any) => {
      const options = {
        name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
        amount: 100, // razorpay takes amount in paisa
        prefill: {
          name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
          email: this.subscriptionbillingUtility.userDetails?.email || 'sana.zohara@gmail.com', // add your email id
          contact: this.subscriptionbillingUtility.userDetails?.phone 
        },
      }
      if(resp?.bajajResponse?.RSPCODE == "0") {
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, resp, options)
      } else if(resp?.bajajResponse?.RESPDESC?.toLowerCase() == "INVALID OTP CODE"?.toLowerCase()) {
        this.BajajEMIOtpErrorMSg = "Invalid OTP";
      } else {
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, resp, options);
      }
      this.spinner.hide();
    }
  })
}
onPaymentFailure(subscriptionbillingUtility, options: any) {
  console.log(subscriptionbillingUtility);
  this.zone.run(() => {
    // add current page routing if payment fails
    // this.subcriptionPayment = subscriptionbillingUtility;
    // let emiData = this.subcriptionPayment.paidOptions;
    // let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    this.options = options;
    if (!subscriptionbillingUtility.selectedPackage) {
      subscriptionbillingUtility.selectedPackage = {};
    }
    subscriptionbillingUtility.selectedPackage.status = 'error';
    let routing = {
      billingAddress: subscriptionbillingUtility.billingAddress,
      selectedPin: subscriptionbillingUtility.selectedPin,
      selectedState: subscriptionbillingUtility.selectedState,
    };
    let body = {
      amount: subscriptionbillingUtility.selectedPackage?.amount,
      creationDate: new Date().toISOString(),
      status: 'aborted',
      userId: this.userDetails?.userId,
      userOrderId: subscriptionbillingUtility.orderId,
      grade: this.userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
    };
    this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp) => {
      console.log('aborted by user');
      // this.dialogRef2.close();
      $('#paymentfail').modal('show');
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Failure',
        package_name: this.subscriptionbillingUtility?.selectedPackage?.name,
        amount: this.subscriptionbillingUtility?.fullPaymentOptions?.amount,
      });
      // this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
      //         { ...subscriptionbillingUtility.selectedPackage, ...this.subscriptionbillingUtility.selectedDuration, ...this.options, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture }, ...{ paymentStatusCapture: subscriptionbillingUtility.paymentStatusCapture }, ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet }, ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData } });
    });
    
  });
}

tryagaina(){
  $('#paymentfail').modal('hide');
}
}
